import styled from "styled-components";

const TimeSentStyled = styled.div`
  h6 {
    color: ${({ theme }) => theme.colors.primaryLighter};
  }
`;

export default TimeSentStyled;
